import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";
(function (module) {
    "use strict";

    module.component("chamfer", {
        template: require("./chamferComponent.html"),
        bindings: {
            yearlyData: "<",
            outputArray: "=",
            startMonth: "<",
            endMonth: "<",
            isValid: "=",
            launchDate: "<",
            onChamferOutputArrayChanged: "&",
            isReadonly: "<"
        },
        controller: [
            "$scope",
            angularServicesNames.$translate,
            "debounce",
            "ChartsConfig",
            "dtpChartService",
            "chamferService",
            ToasterService.componentName,
            FileDownloadService.componentName,
            chamferComponentCtrl
        ]
    });

    function chamferComponentCtrl(
        this: $TSFixMe,
        $scope: $TSFixMe,
        $translate: ng.translate.ITranslateService,
        debounce: $TSFixMe,
        ChartsConfig: $TSFixMe,
        dtpChartService: $TSFixMe,
        chamferService: $TSFixMe,
        toasterService: ToasterService,
        fileDownloadService: FileDownloadService
    ) {
        var $ctrl = this;

        $scope.$watchGroup(["$ctrl.yearlyData", "$ctrl.startMonth", "$ctrl.endMonth", "$ctrl.outputArray"], () => {
            if (angular.isUndefinedOrNull($ctrl.startMonth) || angular.isUndefinedOrNull($ctrl.endMonth)) {
                return;
            }

            $ctrl.labels = dtpChartService.preparePeriodsAndLabels($ctrl.startMonth, $ctrl.endMonth).periods;

            if (
                angular.isUndefinedOrNull($ctrl.outputArray) ||
                (angular.isArray($ctrl.outputArray) && $ctrl.outputArray.length == 0)
            ) {
                if (angular.isUndefinedOrNull($ctrl.outputArray)) {
                    $ctrl.outputArray = new Array($ctrl.labels.length);
                }

                $ctrl.tableData = chamferService.createFromYearlyData(
                    $ctrl.yearlyData,
                    $ctrl.startMonth,
                    $ctrl.endMonth,
                    $ctrl.launchDate,
                    $ctrl.outputArray
                );

                $ctrl.dataToChart = chamferService.createChartDataFromYearlyData(
                    $ctrl.yearlyData,
                    $ctrl.startMonth,
                    $ctrl.endMonth,
                    $ctrl.launchDate,
                    $ctrl.outputArray
                );

                $ctrl.onChamferOutputArrayChanged();
            }

            $ctrl.tableData = chamferService.createFromOutputArray(
                $ctrl.startMonth,
                $ctrl.endMonth,
                $ctrl.launchDate,
                $ctrl.outputArray
            );

            $ctrl.dataToChart = chamferService.createChartDataFromOutputArray(
                $ctrl.startMonth,
                $ctrl.endMonth,
                $ctrl.launchDate,
                $ctrl.outputArray
            );
        });

        $ctrl.valueChange = (
            yearData: $TSFixMe,
            monthData: $TSFixMe,
            monthDataIndex: $TSFixMe,
            prevMonthValue: $TSFixMe
        ) => {
            if (!$ctrl.isReadonly) {
                if (!monthData.value) {
                    monthData.value = parseFloat(prevMonthValue);
                }
                chamferService.valueChange(yearData, monthData, monthDataIndex, $ctrl.outputArray);
                $ctrl.onChamferOutputArrayChanged();
            }
        };

        $ctrl.maxSliderValue = chamferService.maxSliderValue;

        $ctrl.exportTable = () => {
            toasterService.showReportGenerateBusyIndicator(
                () =>
                    fileDownloadService.exportTable("table.xlsx", {
                        columns: [
                            $translate.instant("DTP_TABLE.MONTH.JANUARY"),
                            $translate.instant("DTP_TABLE.MONTH.FEBRUARY"),
                            $translate.instant("DTP_TABLE.MONTH.MARCH"),
                            $translate.instant("DTP_TABLE.MONTH.APRIL"),
                            $translate.instant("DTP_TABLE.MONTH.MAY"),
                            $translate.instant("DTP_TABLE.MONTH.JUNE"),
                            $translate.instant("DTP_TABLE.MONTH.JULY"),
                            $translate.instant("DTP_TABLE.MONTH.AUGUST"),
                            $translate.instant("DTP_TABLE.MONTH.SEPTEMBER"),
                            $translate.instant("DTP_TABLE.MONTH.OCTOBER"),
                            $translate.instant("DTP_TABLE.MONTH.NOVEMBER"),
                            $translate.instant("DTP_TABLE.MONTH.DECEMBER"),
                            $translate.instant("DTP_TABLE.DATA.SUM")
                        ],
                        rows: generateRowsForExport()
                    }),
                "EXCEL_EXPORT_GENERATING",
                "EXCEL_EXPORT_GENERATED"
            );
        };

        function generateRowsForExport() {
            var rows = [];
            for (const yearData of $ctrl.tableData) {
                const sum = yearData.data.map((x: $TSFixMe) => x.value).reduce((a: $TSFixMe, b: $TSFixMe) => a + b, 0);
                rows.push({
                    header: yearData.year,
                    values: [...yearData.data.map((x: $TSFixMe) => x.value), sum]
                });
            }
            return rows;
        }

        $ctrl.percentageOfYearChange = (yearData: $TSFixMe, monthData: $TSFixMe, monthDataIndex: $TSFixMe) => {
            chamferService.percentageOfYearChange(yearData, monthData, monthDataIndex, $ctrl.outputArray);
            $ctrl.onChamferOutputArrayChanged();
        };

        $ctrl.resetValues = (yearData: $TSFixMe) => {
            chamferService.resetValues(yearData, $ctrl.startMonth, $ctrl.endMonth, $ctrl.launchDate, $ctrl.outputArray);
            $ctrl.onChamferOutputArrayChanged();
        };

        $ctrl.endSliderDone = (id: $TSFixMe) => {
            const year = parseInt(id.split("_")[0]);
            const yearData = $ctrl.tableData[year - $ctrl.startMonth.getFullYear()];
            chamferService.proportionChanged(yearData, $ctrl.outputArray);
            $ctrl.onChamferOutputArrayChanged();
        };

        $ctrl.datasetOverride = ChartsConfig.datasetOverride;
        $ctrl.options = ChartsConfig.options;
        $scope.$on("LanguageChanged", () => resetChartTranslations());
        resetChartTranslations();

        function resetChartTranslations() {
            $translate(["CHART_SERIES.BEFORE_CHAMFER", "CHART_SERIES.AFTER_CHAMFER"]).then(function (
                translations: $TSFixMe
            ) {
                $ctrl.series = [
                    translations["CHART_SERIES.BEFORE_CHAMFER"],
                    translations["CHART_SERIES.AFTER_CHAMFER"]
                ];
            });
        }
    }
})(angular.module("topline.chamferForecast"));
